import { InteractionInfo } from './InteractionInfo';
import { DatosPersonales } from './DatosPersonales';
import { DatosEmpresa } from './DatosEmpresa';
import { NavigationHistory } from './NavigationHistory';
import { FormElements } from './FormElements';
import { DatosChat } from './DatosChat';

export class Contexto {

    public modificarDatosUrl: string;
    // servicio donde se instancia el asistente
    public idServicio: string;
    // codigo del asistente a dibujar. Permite dibujar diferentes asistentes en un mismo servicio en línea
    public codAsistente: string;
    public codAsistenteError: string;
    public codAsistenteOriginal: string;
    public descServicio: string;
    public tipoFormulario: string;
    public datosEmpresa: DatosEmpresa;
    public interactionInfo: InteractionInfo;
    public datosPersonales: DatosPersonales;
    public persIdentificador: number;
    // A la fecha (Feb 7, 2022) codigoTema se mapea con el concepto de "codigoTemaDestinatario"
    public codigoTema: string;
    // Etiqueta se inyecta para que la consuma el formulario de asistencia;
    // puede ser el nombre de un nodo del arbol o una etiqueta inyectada desde fuera (ej: nombre de un servicio en linea)
    public etiquetaTema: string;
    public idMenu: string;
    public historialMenus: string[];
    // Es el id de Formulario asociado al Menu (configurado en el aliss-bkend-concierge.xml)
    public idFormAsociado: string;

    // codigo del nodo del arbol donde se solicita asistencia
    public codigoNodoArbol: string;
    // Etiqueta del nodo del arbol donde se solicita asistencia (ejemplo formulario)
    public etiquetaNodoArbol: string;

    // navigationHistory = informacion del handler utilizado anteriormente
    public navigationHistory: NavigationHistory;

    public esFormulario: boolean;

    public esReporteError: boolean;
    public evitarValidarSesionPortal: boolean;
    public formElements: FormElements;

    public idNodo: string;
    public idAsistente: number;
    public open: boolean;
    public hideAfterClose: boolean;
    public hideAllButtonsForm: boolean;
    public fromAnonymous: boolean;
    public esEntornoAnonimo: boolean;
    public captchaHabilitado: boolean;
    public urlSitioAutenticar: string;
    public urlSitioBps: string;
    public goInside: boolean;
    public habilitado: boolean;
    public refresh: boolean;
    public clavePublicaV2:string;
    public clavePublicaV3:string;
    public contexto:string;
    public requiereAutenticacion: boolean;
    public errorCarga: boolean;
    public mensajeErrorCarga:string;
    public destinatarioChat: DatosChat;
    constructor() {
        this.interactionInfo = new InteractionInfo();
        this.datosPersonales = new DatosPersonales();
        this.datosEmpresa = new DatosEmpresa();
        this.navigationHistory = new NavigationHistory();
        this.formElements = new FormElements();
        this.destinatarioChat = new DatosChat();
        this.historialMenus = [];
    }

    // Método para agregar un menú al historial
    public agregarMenuAlHistorial(menuId: string) {
        this.historialMenus.push(menuId);
    }

    // Método para obtener el menú actualmente abierto
    public obtenerMenuActual(): string {
        return this.historialMenus.length > 0 ? this.historialMenus[this.historialMenus.length - 1] : null;
    }

    // Método para volver al menú anterior en el historial
    public obtenerMenuAnterior(): string {
        if (this.historialMenus.length > 1) {
            return this.historialMenus[this.historialMenus.length - 2]; // Retorna el menú anterior
        } else {
            return null; // No hay menú anterior, retorno null
        }
    }
}
